export default __webpack_public_path__ + "static/media/card_cover.a75e9dd1.png";